module.exports = __webpack_public_path__ + "img/badge-tail.4696023.svg";